import React, { useState } from "react";
import { FiEye, FiChevronDown, FiChevronUp } from "react-icons/fi";
import FileUpload from "./FileUpload";

const UploadDocumentSection = ({ onSave, onEdit }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isSaved, setIsSaved] = useState(false);

  const [formData, setFormData] = useState({
    aadhaarFront: null,
    aadhaarBack: null,
    panCard: null,
    shopPhoto: null,
    selfieWithSalesPerson: null,
    selfieWithDocuments: null,
    signaturePhoto: null,
    passbookOrChequeBook: null,
    gstcertificate: null,
  });

  const [errors, setErrors] = useState({});

  const allowedExtensions = ["jpg", "jpeg", "png", "gif"];
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

  /* ---------------- FILE CHANGE ---------------- */

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (!files || !files.length) return;

    const file = files[0];
    const ext = file.name.split(".").pop().toLowerCase();

    let error = "";
    if (!allowedExtensions.includes(ext)) {
      error = "Only image files are allowed";
    } else if (file.size > MAX_FILE_SIZE) {
      error = "File size must be less than 5MB";
    }

    setFormData((prev) => ({
      ...prev,
      [name]: error ? null : file,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  /* ---------------- VALIDATION ---------------- */

  const validate = () => {
    const e = {};

    Object.keys(formData).forEach((key) => {
      // ❌ gstcertificate is optional
      if (key === "gstcertificate") return;

      if (!formData[key]) {
        e[key] = "This document is required";
      }
    });

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  /* ---------------- SAVE ---------------- */

  const handleSave = () => {
    if (!validate()) return;
    setIsSaved(true);
    onSave(formData);
  };

  /* ---------------- EDIT ---------------- */

  const handleEdit = () => {
    setIsSaved(false);
    onEdit();
  };

  const disabled = isSaved;

  /* ---------------- UI ---------------- */

  return (
    <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
      {/* HEADER */}
      <div
        className="flex cursor-pointer items-center justify-between border-b px-6 py-4"
        onClick={() => setIsOpen((p) => !p)}
      >
        <h3 className="text-sm font-semibold text-gray-800">
          Upload Documents
        </h3>
        {isOpen ? <FiChevronUp /> : <FiChevronDown />}
      </div>

      {isOpen && (
        <div className="p-6">
          {/* UPLOAD GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 min-h-[380px]">
            {Object.entries(formData).map(([key, file]) => {
              const hasError = errors[key];

              return (
                <div
                  key={key}
                  className={`relative rounded-lg p-3 border
                    ${
                      hasError
                        ? "border-red-400 bg-red-50"
                        : file
                        ? "border-[#0A2A4F] bg-slate-50"
                        : "border-slate-200 bg-white"
                    }`}
                >
                  <FileUpload
                    label={`${key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (s) => s.toUpperCase())} *`}
                    name={key}
                    value={file}
                    onChange={handleFileChange}
                    disabled={disabled}
                  />

                  {/* Preview */}
                  {file && !hasError && (
                    <a
                      href={
                        typeof file === "string"
                          ? file
                          : URL.createObjectURL(file)
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="absolute top-3 right-3 text-[#0A2A4F]"
                    >
                      <FiEye size={18} />
                    </a>
                  )}

                  {hasError && (
                    <p className="text-red-600 text-xs mt-1">
                      {hasError}
                    </p>
                  )}
                </div>
              );
            })}
          </div>

          {/* SAVE / EDIT */}
          <div className="mt-6">
            {!isSaved ? (
              <button
                onClick={handleSave}
                className="rounded-full bg-green-600 px-8 py-2 text-sm text-white"
              >
                Save
              </button>
            ) : (
              <button
                onClick={handleEdit}
                className="rounded-full bg-gray-500 px-8 py-2 text-sm text-white"
              >
                Edit
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadDocumentSection;
